import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import ChannelsList from "../components/Channels/ChannelsList/ChannelsList";
import SelectPackage from "../components/Channels/SelectPackage/SelectPackage";

const Channels = () => {
  const [channelsData, setChannelsData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [selectedChannels, setSelectedChannels] = useState([]);

  const [core, setCore] = useState([]);
  const [essentials, setEssentials] = useState([]);
  const [elite, setElite] = useState([]);
  const [ultimate, setUltimate] = useState([]);
  const [sportsFanatic, setSportsFanatic] = useState([]);
  const [miniSports, setMiniSports] = useState([]);
  const [latino, setLatino] = useState([]);
  const [starz, setStarz] = useState([]);
  const [showtime, setShowtime] = useState([]);
  const [hbo, setHbo] = useState([]);

  useEffect(() => {
    fetch("/json/channels/channels.json")
      .then((res) => res.json())
      .then((data) => {
        setChannelsData(data);
        setIsLoading(false);
      });
  }, []);

  useMemo(() => {
    const updatePackages = () => {
      const packageChannels = {
        core: [],
        essentials: [],
        elite: [],
        ultimate: [],
        sportsFanatic: [],
        miniSports: [],
        latino: [],
        starz: [],
        showtime: [],
        hbo: [],
      };
      channelsData.channels.forEach((channel) => {
        let binaryValue = channel.binary;

        if (binaryValue > 0) {
          if (binaryValue >= 512) {
            packageChannels.hbo.push(channel);
            binaryValue -= 512;
          }
          if (binaryValue >= 256 && binaryValue < 512) {
            packageChannels.showtime.push(channel);
            binaryValue -= 256;
          }
          if (binaryValue >= 128 && binaryValue < 256) {
            packageChannels.starz.push(channel);
            binaryValue -= 128;
          }
          if (binaryValue >= 64 && binaryValue < 128) {
            packageChannels.latino.push(channel);
            binaryValue -= 64;
          }
          if (binaryValue >= 32 && binaryValue < 64) {
            packageChannels.miniSports.push(channel);
            binaryValue -= 32;
          }
          if (binaryValue >= 16 && binaryValue < 32) {
            packageChannels.sportsFanatic.push(channel);
            binaryValue -= 16;
          }
          if (binaryValue >= 8 && binaryValue < 16) {
            packageChannels.ultimate.push(channel);
            binaryValue -= 8;
          }
          if (binaryValue >= 4 && binaryValue < 8) {
            packageChannels.elite.push(channel);
            binaryValue -= 4;
          }
          if (binaryValue >= 2 && binaryValue < 4) {
            packageChannels.essentials.push(channel);
            binaryValue -= 2;
          }
          if (binaryValue >= 1 && binaryValue < 2) {
            packageChannels.core.push(channel);
            binaryValue -= 1;
          }
        }
      });

      setHbo(packageChannels.hbo);
      setShowtime(packageChannels.showtime);
      setStarz(packageChannels.starz);
      setLatino(packageChannels.latino);
      setMiniSports(packageChannels.miniSports);
      setSportsFanatic(packageChannels.sportsFanatic);
      setUltimate(packageChannels.ultimate);
      setElite(packageChannels.elite);
      setEssentials(packageChannels.essentials);
      setCore(packageChannels.core);
    };

    if (channelsData && channelsData.channels) {
      updatePackages();
    }
  }, [channelsData]);

  useEffect(() => {
    if (selectedPackage && channelsData) {
      switch (selectedPackage) {
        case "core":
          setSelectedChannels(core);
          break;
        case "essentials":
          setSelectedChannels(essentials);
          break;
        case "elite":
          setSelectedChannels(elite);
          break;
        case "ultimate":
          setSelectedChannels(ultimate);
          break;
        case "sportsFanatic":
          setSelectedChannels(sportsFanatic);
          break;
        case "miniSports":
          setSelectedChannels(miniSports);
          break;
        case "latino":
          setSelectedChannels(latino);
          break;
        case "starz":
          setSelectedChannels(starz);
          break;
        case "showtime":
          setSelectedChannels(showtime);
          break;
        case "hbo":
          setSelectedChannels(hbo);
          break;
        default:
          setSelectedChannels([]);
          break;
      }
    }
  }, [
    selectedPackage,
    channelsData,
    core,
    essentials,
    elite,
    ultimate,
    sportsFanatic,
    miniSports,
    latino,
    starz,
    showtime,
    hbo,
  ]);

  return (
    <div>
      <Box sx={{ px: 4, pt: 8 }}>
        <Typography variant="h3" className="sectionTitle">
          Channels
        </Typography>
        <Stack
          sx={{ mt: 4 }}
          direction="row"
          alignItems="flex-start"
          gap={{
            xs: 2,
            md: 6,
          }}
        >
          <Typography sx={{ mt: 2.5 }} variant="body1">
            Select a package to view the channels included.
          </Typography>
          {!isLoading && (
            <SelectPackage
              packages={channelsData?.packages}
              selectedPackage={selectedPackage}
              setSelectedPackage={setSelectedPackage}
            />
          )}
        </Stack>
      </Box>
      <Box>
        {isLoading ? (
          <Box sx={{ textAlign: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <ChannelsList selectedChannels={selectedChannels} />
          </>
        )}
      </Box>
    </div>
  );
};

export default Channels;
